import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: null,
  location: {
    pathname: "/",
    search: "",
    hash: "",
  },
};

const routerSlice = createSlice({
  name: "router",
  initialState,
  reducers: {
    locationChanged(state, action) {
      const { location, navAction } = action.payload;
      state.location = location;
      state.action = navAction;
    },
  },
});

export const { locationChanged } = routerSlice.actions;
export default routerSlice.reducer;
